let lastScrollY = window.scrollY; 

// Get elements using querySelector
const header = document.querySelector(".main-header-sticky-trigger");
const announcementBar = document.querySelector(".announcement-sticky-trigger");

window.addEventListener("scroll", () => {
  if (window.scrollY > 15) {
    header.classList.add("user-scrolls-down");
  } else {
    header.classList.remove("user-scrolls-down");
  }

  if (window.scrollY < lastScrollY) {
    header.classList.add("user-scrolls-up");
  } else {
    header.classList.remove("user-scrolls-up");
  }

  lastScrollY = window.scrollY;
});
